import React from 'react';
import '../Login/Login.css';
import { BRAND_LOGO, POLICY_LINKS } from '../../constants';

interface AuthCardProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  children: React.ReactNode;
}

/**
 * The page shell shared by Login and Signup: background, centred card, logo,
 * title and subtitle. Each page passes its step-dependent title and subtitle
 * and renders its own alerts and forms as children. Styles live in Login.css.
 *
 * The footer links every policy page (POLICY_LINKS). These are the only pages
 * a signed-out visitor sees, and the payment provider's domain review needs
 * all three links on them.
 */
const AuthCard: React.FC<AuthCardProps> = ({ title, subtitle, children }) => (
  <div className="login-container">
    <div className="login-background">
      <div className="background-overlay"></div>
    </div>

    <div className="login-content">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src={BRAND_LOGO.src} alt={BRAND_LOGO.alt} className="logo-image" width="233" height="80" />
          </div>
          <h1 className="login-title">{title}</h1>
          <p className="login-subtitle">{subtitle}</p>
        </div>
        {children}
      </div>
      <nav className="auth-policy-links" aria-label="Policies">
        {POLICY_LINKS.map((link) => (
          <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer">
            {link.label}
          </a>
        ))}
      </nav>
    </div>
  </div>
);

export default AuthCard;
